var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3EA4CC;}\n\t.st1{fill:#62B2F4;}\n\t.st2{fill:#FF7171;}\n\t.st3{fill:#4D4D4D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stopwatch_Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 477.8,
    y: 226.5,
    className: "st0",
    width: 44.4,
    height: 44.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M641.9,311.2l12.5-16.2c3.2-4.2,2.4-10.1-1.7-13.4l-20.1-15.4c-4.2-3.2-10.1-2.4-13.4,1.7l-13,16.9 c-31.2-18.4-67.5-28.9-106.3-28.9c-115.8,0-210,94.2-210,210c0,115.8,94.2,210,210,210s210-94.2,210-210 C710,404.7,683.8,349.6,641.9,311.2z M588.4,609.1l-12.1-21l-8.5,4.9l12.1,21c-22.4,12.1-47.9,19.3-74.9,20.1v-24.2h-9.8v24.2 c-27.1-0.8-52.5-8-74.9-20.1l12.1-21l-8.5-4.9l-12.1,21c-22.3-13.8-41.1-32.6-54.9-54.9l21-12.1l-4.9-8.5l-21,12.1 c-12.1-22.4-19.3-47.9-20.1-74.9H356V461h-24.2c0.8-27.1,8-52.5,20.1-74.9l21,12.1l4.9-8.5l-21-12.1 c13.8-22.3,32.6-41.1,54.9-54.9l12.1,21l8.5-4.9l-12.1-21c22.4-12.1,47.9-19.3,74.9-20.1v24.2h9.8v-24.2 c27.1,0.8,52.5,8,74.9,20.1l-12.1,21l8.5,4.9l12.1-21c22.3,13.8,41.1,32.6,54.9,54.9l-21,12.1l4.9,8.5l21-12.1 c12.1,22.4,19.3,47.9,20.1,74.9H644v9.8h24.2c-0.8,27.1-8,52.5-20.1,74.9l-21-12.1l-4.9,8.5l21,12.1 C629.5,576.5,610.6,595.3,588.4,609.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.3,234.8h-62.5c-5.3,0-9.5-4.3-9.5-9.5v-21.4c0-5.3,4.3-9.5,9.5-9.5h62.5c5.3,0,9.5,4.3,9.5,9.5v21.4 C540.8,230.6,536.5,234.8,531.3,234.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559,363.9c-17.9-10.4-38.2-15.8-58.8-15.8L500,465.9l102.1-58.8C591.7,389.2,576.9,374.3,559,363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M608,400.4l-94.2,46.7c-3.8-2.8-8.6-4.5-13.7-4.5c-12.9,0-23.3,10.4-23.3,23.3c0,12.9,10.4,23.3,23.3,23.3 s23.3-10.4,23.3-23.3c0-1-0.1-1.9-0.2-2.9l87.3-58.5C612.8,402.8,610.6,399.1,608,400.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5671eab410d87319533210efd37e419c.svg";
export { ForwardRef as ReactComponent };